import { BaseDTO } from '../global/base.dto';

export class ParameterDTO extends BaseDTO {

    key: string;

    value: string;

    defaultValue: string;

    type: number;

    inputType: number;

    minValue: string;

    maxValue: string;

    fixedValues: string;

    description: string;

}
